/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Visa_Categories_LabelInputs */

const en_visa_categories_label = /** @type {(inputs: Visa_Categories_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`VISA CATEGORIES`)
};

const pt_visa_categories_label = /** @type {(inputs: Visa_Categories_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`CATEGORIAS DE VISTO`)
};

const es_visa_categories_label = /** @type {(inputs: Visa_Categories_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`CATEGORÍAS DE VISA`)
};

/**
* | output |
* | --- |
* | "VISA CATEGORIES" |
*
* @param {Visa_Categories_LabelInputs} inputs
* @param {{ locale?: "en" | "pt" | "es" }} options
* @returns {LocalizedString}
*/
export const visa_categories_label = /** @type {((inputs?: Visa_Categories_LabelInputs, options?: { locale?: "en" | "pt" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Visa_Categories_LabelInputs, { locale?: "en" | "pt" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt") return pt_visa_categories_label(inputs)
	if (locale === "es") return es_visa_categories_label(inputs)
	return en_visa_categories_label(inputs)
});